import { useMutation } from '@apollo/react-hooks';

import {
  CREATE_ENSEIGNE,
  UPDATE_ENSEIGNE,
} from '../../graphql/enseigne/mutation';
import {
  CreateEnseigne,
  CreateEnseigneVariables,
} from '../../graphql/enseigne/types/CreateEnseigne';
import {
  UpdateEnseigne,
  UpdateEnseigneVariables,
} from '../../graphql/enseigne/types/UpdateEnseigne';
import { PhysicalModel, TypeEnseigne } from '../../types/graphql-global-types';

export type CreateEnseigneInput = {
  type: TypeEnseigne | null;
  name: string;
  zipCode: string | null;
  city: string | null;
  phone: string | null;
  email: string | null;
  SIREN: string | null;
  IBAN: string | null;
  BIC: string | null;
  address: string | null;
  country: string | null;
  physicalModel: PhysicalModel | null;
  socialReason: string | null;
  entityIds: number[] | null;
};

export const useCreateEnseign = () => {
  return useMutation<CreateEnseigne, CreateEnseigneVariables>(CREATE_ENSEIGNE);
};

export const useUpdateEnseign = () => {
  return useMutation<UpdateEnseigne, UpdateEnseigneVariables>(UPDATE_ENSEIGNE);
};
